<template>
  <div class="flex flex-col gap-4">
    <div class="grid grid-cols">
      <div class="card px-[15%] rounded-[5px]">
        <p class="text-[21px] font-semibold mb-[20px]">What's your Budget?</p>
        <div class="flex gap-6 mb-6 flex-col">
         <div class="flex items-center gap-1">
          <input
            class="append-icon block pl-4 bg-inputbg appearance-none rounded-[5px] h-14 w-[50%] py-2 text-black"
            :class="[empty ? 'border-2 border-red-500 ' : '']"
            id="name"
            type="text"
            :min="[$store.state.auth.country_code === 'EG' ? '20000' : '2500']"
            :max="[
              $store.state.auth.country_code === 'EG' ? '10000000' : '1250000',
            ]"
            placeholder=""
            v-model="stepTh.budget"
            @input="formatNumber"

          />
          <span v-if="stepTh.budget" class="text-primary font-semibold text-[18px]">{{$store.state.auth.country_code === 'EG' ? "EGP" :"SAR"}}</span>
         </div>
          <p v-if="empty" class="text-red-400 text-[14px] p-0">
            Minimum of {{ minBudget }} / Month
          </p>
        </div>
        <!-- <p class="text-[21px] font-semibold mb-[20px] capitalize">What You’ll Get</p> -->
        <p class="text-[21px] font-semibold mb-[20px] capitalize">
          Campaign Outcome
        </p>

        <div class="card w-auto rounded-[5px] shadow-md">
          <div class="flex justify-around">
            <div class="flex flex-col">
              <div class="flex flex-col items-center justify-between">
                <!-- <img src="../../assets/SVGs/Eye.svg" > -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                >
                  <g id="Impressions" transform="translate(0)">
                    <circle
                      id="Ellipse_1163"
                      data-name="Ellipse 1163"
                      cx="18"
                      cy="18"
                      r="18"
                      transform="translate(0)"
                      fill="none"
                    />
                    <g id="eye" transform="translate(8.174 10.351)">
                      <path
                        id="Path_25818"
                        data-name="Path 25818"
                        d="M19.047,8.192A10.84,10.84,0,0,0,9.822,2.655,10.84,10.84,0,0,0,.6,8.192a4.017,4.017,0,0,0,0,4.225,10.84,10.84,0,0,0,9.226,5.537,10.84,10.84,0,0,0,9.226-5.537A4.017,4.017,0,0,0,19.047,8.192Zm-1.4,3.368a9.261,9.261,0,0,1-7.83,4.757,9.261,9.261,0,0,1-7.83-4.757,2.388,2.388,0,0,1,0-2.511,9.261,9.261,0,0,1,7.83-4.757,9.254,9.254,0,0,1,7.83,4.757A2.388,2.388,0,0,1,17.652,11.56Z"
                        transform="translate(0.004 -2.655)"
                      />
                      <path
                        id="Path_25819"
                        data-name="Path 25819"
                        d="M11.093,7a4.093,4.093,0,1,0,4.093,4.093A4.093,4.093,0,0,0,11.093,7Zm0,6.548a2.456,2.456,0,1,1,2.456-2.456A2.456,2.456,0,0,1,11.093,13.548Z"
                        transform="translate(-1.267 -3.443)"
                      />
                    </g>
                  </g>
                </svg>

                <p class="text-[18] font-semibold flex">Average Impressions</p>
              </div>
              <p class="text-[16px] text-primary flex justify-center">
                {{ impressions }}
                <!-- 170k - 150k -->
              </p>
            </div>
            <!-- <div class="flex flex-col">
                            <div class="flex flex-col items-center justify-between">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="36"
                                    height="36"
                                    viewBox="0 0 36 36"
                                >
                                    <g
                                        id="Group_17054"
                                        data-name="Group 17054"
                                        transform="translate(-698 -576)"
                                    >
                                        <path
                                            id="Path_25871"
                                            data-name="Path 25871"
                                            d="M14,0A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z"
                                            transform="translate(698 576)"
                                            fill="none"
                                            opacity="0.3"
                                        />
                                        <path
                                            id="road"
                                            d="M14.775,2.846A3.437,3.437,0,0,0,11.385,0H5.13A3.437,3.437,0,0,0,1.739,2.849L.053,12.488a3.442,3.442,0,0,0,3.39,4.036h9.639a3.442,3.442,0,0,0,3.391-4.039Zm-.11,11.563a2.065,2.065,0,0,1-1.584.737H3.443a2.065,2.065,0,0,1-2.034-2.422L3.094,3.086A2.065,2.065,0,0,1,5.13,1.377h6.255a2.065,2.065,0,0,1,2.034,1.707l1.7,9.639A2.065,2.065,0,0,1,14.665,14.409ZM8.951,3.442V4.819a.688.688,0,0,1-1.377,0V3.442a.688.688,0,1,1,1.377,0Zm0,4.131V8.95a.688.688,0,0,1-1.377,0V7.573a.688.688,0,1,1,1.377,0Zm0,4.131v1.377a.688.688,0,0,1-1.377,0V11.7a.688.688,0,1,1,1.377,0Z"
                                            transform="translate(703.737 581.738)"
                                        />
                                    </g>
                                </svg>

                                <p class="text-[18] font-semibold flex">Average Distance</p>
                            </div>
                            <p class="text-[16px] text-primary flex justify-center">
                                {{ distance }}
                            </p>
                        </div> -->
            <div class="flex flex-col">
              <div class="flex flex-col items-center justify-between">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                >
                  <g
                    id="Group_16535"
                    data-name="Group 16535"
                    transform="translate(-989 -145)"
                  >
                    <path
                      id="Path_25871"
                      data-name="Path 25871"
                      d="M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z"
                      transform="translate(989 145)"
                      fill="none"
                      opacity="0.3"
                    />
                    <g
                      id="_01_align_center"
                      data-name="01 align center"
                      transform="translate(998.2 154.2)"
                    >
                      <path
                        id="Path_26110"
                        data-name="Path 26110"
                        d="M8.8,1.467a7.357,7.357,0,0,1,5.223,2.2H11V5.133h3.772a1.363,1.363,0,0,0,1.362-1.362V0H14.667V2.257A8.787,8.787,0,0,0,0,8.8H1.467A7.342,7.342,0,0,1,8.8,1.467Z"
                      />
                      <path
                        id="Path_26111"
                        data-name="Path 26111"
                        d="M16.667,12A7.323,7.323,0,0,1,4.111,17.133H7.133V15.667H3.362A1.363,1.363,0,0,0,2,17.029V20.8H3.467V18.543A8.787,8.787,0,0,0,18.134,12Z"
                        transform="translate(-0.533 -3.2)"
                      />
                    </g>
                  </g>
                </svg>

                <p class="text-[18] font-semibold flex justify-center">
                  Ad Loops
                </p>
              </div>
              <p class="text-[16px] text-primary flex justify-center">
                {{ ad_loops }}
              </p>
            </div>
            <div class="flex flex-col">
              <div
                class="flex flex-col items-center justify-center text-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                >
                  <g
                    id="Distance_Covered"
                    data-name="Distance Covered"
                    transform="translate(0)"
                  >
                    <path
                      id="Path_25871"
                      data-name="Path 25871"
                      d="M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z"
                      transform="translate(0)"
                      fill="none"
                      opacity="0.3"
                    />
                    <path
                      id="tachometer-slow"
                      d="M16.773,17.83a2.473,2.473,0,0,1-3.341.105l-.842-.728a.821.821,0,0,1,1.073-1.242l.843.728a.82.82,0,0,0,1.112-.03A8.2,8.2,0,1,0,4.04,16.632a.833.833,0,0,0,1.144.062l.843-.729A.821.821,0,1,1,7.1,17.207l-.842.728a2.494,2.494,0,0,1-3.38-.144,9.845,9.845,0,1,1,13.894.038ZM9.845,9.2a1.648,1.648,0,0,0-.425.056l-3.1-3.1a.82.82,0,1,0-1.16,1.16l3.1,3.1A1.641,1.641,0,1,0,9.845,9.2Z"
                      transform="translate(8.152 8.234)"
                    />
                  </g>
                </svg>

                <p class="text-[18] font-semibold flex justify-center">
                  Minutes
                </p>
              </div>
              <p class="text-[16px] text-primary flex justify-center">
                {{ minutes }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols">
      <div class="card px-[15%] rounded-[5px]">
        <!-- <p class="text-[21px] font-semibold mb-[20px]">Set the duration of your campaign</p> -->
        <p class="text-[21px] font-semibold mb-[20px]">Campaign Duration</p>

        <div class="flex gap-6">
          <div class="flex gap-6 mb-10 w-full">
            <form class="w-full" @submit.prevent>
              <div class="">
                <v-date-picker
                  v-model="stepTh.duration"
                  mode="date"
                  :masks="masks"
                  is-range
                  :model-config="modelConfig"
                  :minDate="settDate"
                  :class="[_empty ? 'border-2 border-red-500' : '']"
                >
                  <template v-slot="{ inputValue, inputEvents, isDragging }">
                    <div
                      class="flex flex-col sm:flex-row justify-start items-center"
                    >
                      <div class="relative flex-grow">
                        <svg
                          class="text-gray-600 w-4 h-full mx-2 absolute pointer-events-none"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          ></path>
                        </svg>
                        <input
                          class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                          :class="
                            isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue.start"
                          v-on="inputEvents.start"
                        />
                      </div>
                      <span class="flex-shrink-0 m-2">
                        <svg
                          class="w-4 h-4 stroke-current text-gray-600"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3"
                          />
                        </svg>
                      </span>
                      <div class="relative flex-grow">
                        <svg
                          class="text-gray-600 w-4 h-full mx-2 absolute pointer-events-none"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          ></path>
                        </svg>
                        <input
                          class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                          :class="
                            isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue.end"
                          v-on="inputEvents.end"
                        />
                      </div>
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </form>
          </div>
        </div>
        <div>
          <!-- <p>Duration : 2 weeks</p> -->
          <p v-if="_empty" class="text-red-400 text-[14px] p-0">
            Please set the duration of your campaign!
          </p>
          <!-- {{ new Date(stepTh.duration.start).toDateString() }} -->
          <p class="text-[21px] font-semibold">
            Start Date:
            <span class="text-[18px] font-normal">{{
              stepTh.duration.start
            }}</span>
          </p>
          <p class="text-[21px] font-semibold">
            End Date:
            <span class="text-[18px] font-normal">{{
              stepTh.duration.end
            }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="flex gap-2 flex-row-reverse mt-4">
    <button
      class="bg-primary p-2 px-[66px] rounded-[5px] text-white"
      @click="next()"
      v-if="$store.state.step < 4"
    >
      Next
    </button>
    <button
      class="bg-primary p-2 px-[66px] rounded-[5px] text-white"
      v-if="$store.state.step == 4"
    >
      Submit
    </button>
    <button
      class="bg-white p-2 px-[66px] rounded-[5px] text-primary border-2 border-primary"
      @click="back()"
      v-if="$store.state.step > 1"
    >
      Back
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      masks: {
        input: "YYYY-MM-DD",
      },
      // timezone: "12 AM",
      modelConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "00:00:00",
        },
      },
      stepTh: {
        budget: '',
        duration: {
          start: null,
          end: null,
        },
      },
      empty: false,
      _empty: false,
      minBudget: null,
      adLoop:null
    };
  },

  mounted() {
    this.stepTh = this.step_three;
    this.minBudget = this.getCenterCoordinates();
  },
  
  methods: {
    formatNumber() {
      let value = this.stepTh.budget.replace(/[^\d]/g, ''); // Remove all non-digit characters
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas every three digits
      this.stepTh.budget = value;
    },
    getCenterCoordinates() {
      const country = localStorage.getItem("country_code");

      let minBudget = this.minBudget;

      if (country === "EG") {
        minBudget = "20,000 EGP"; // cairo budget
      } else if (country === "SA") {
        minBudget = "2,500 SAR"; //riydh budget
      }

      return minBudget;
    },
    setOption(option) {
      this.selectedOption = option;
      this.isOptionsExpanded = false;
    },
    next() {
      if (localStorage.getItem('country_code') === "EG") {
        if (this.stepTh.budget <= 19999 || this.stepTh.budget == null) {
          this.empty = true;
          this._empty = false;
          this.$store.state.step = this.$store.state.step;
          window.scrollTo(0, 0);
        } else if (this.stepTh.duration.start === null) {
          this._empty = true;
          this.empty = false;
          this.$store.state.step = this.$store.state.step;
          window.scrollTo(0, 0);
        } else if (this.$store.state.step < 4) {
          this.$store.commit("updataStepTH", this.stepTh);
          this.stepTh.budget =  parseFloat(this.stepTh.budget.replace(/,/g, ''));
          this.$store.state.step = this.$store.state.step + 1;
          window.scrollTo(0, 0);
        }
      } else if (localStorage.getItem('country_code') === "sa") {
        if (this.stepTh.budget <= 2499 || this.stepTh.budget == null) {
          this.empty = true;
          this._empty = false;
          this.$store.state.step = this.$store.state.step;
          window.scrollTo(0, 0);
        } else if (this.stepTh.duration.start === null) {
          this._empty = true;
          this.empty = false;
          this.$store.state.step = this.$store.state.step;
          window.scrollTo(0, 0);
        } else if (this.$store.state.step < 4) {
          this.$store.commit("updataStepTH", this.stepTh);
          this.stepTh.budget =  parseFloat(this.stepTh.budget.replace(/,/g, ''));
          this.$store.state.step = this.$store.state.step + 1;
          window.scrollTo(0, 0);
        }
      }
    },
    back() {
      if (
        this.$store.state.step === 3 &&
        this.$store.state.step_one.advertisingGoal === "Awareness"
      ) {
        this.$store.state.step = 1;
      } else {
        if (this.$store.state.step > 1) {
          this.$store.state.step = this.$store.state.step - 1;
        }
      }
      window.scrollTo(0, 0);
    },
  },
  computed: {
    ...mapGetters(["step_three"]),
    settDate() {
      const date = new Date();

      date.setDate(date.getDate() +7 );
      return date;
    },
    formattedBudget: {
        get() {
          const currencySymbol = localStorage.getItem('country_code') === 'EG' ? 'EGP' : 'SAR';
            return `${currencySymbol} ${this.stepTh.budget}`;
        },
        set(value) {
            // If you need to parse the value, you can handle it here
            this.stepTh.budget = value;
        }
    },
    // numericBudget() {
    //   return parseFloat(this.stepTh.budget.replace(/,/g, '')) || 0;
    // },
    totalBudget() {
      // const numericValue = parseFloat(this.stepTh.budget.replace(/,/g, ''));

      // return parseInt(numericValue) * 1;
      return parseFloat(this.stepTh.budget.replace(/,/g, '')) || 0;

    },
   
    impressions() {
        if (!this.totalBudget) {
          return "-";
        }
        
        let cost, countryCode;
        
        if (localStorage.getItem("country_code") === "EG") {
          cost = 0.09;
          countryCode = "EG";
          var val = this.totalBudget / cost;
        } else if (localStorage.getItem("country_code") === "sa") {
          var val = this.adLoop * 25
          countryCode = "SA";
        }

        var min = Math.round((val * 0.80) / 1e3);
        var max = Math.round((val * 1.20) / 1e3);

        if (min >= 999) {
          min = (min / 1000).toFixed(1) + " million ";
        }else{
          min = min.toFixed(0) + "K";
        }

        if (max >= 999) {
          max = (max / 1000).toFixed(1) + " million ";
        }else{
          max = max.toFixed(0) + "K";
        }

        return `${min} ~ ${max}`;
    },
      ad_loops() {
        if (!this.totalBudget) {
          return "-";
        }

        let cost, countryCode;

        if (localStorage.getItem("country_code") === "EG") {
          cost = 0.65;
          countryCode = "EG";
        } else if (localStorage.getItem("country_code") === "sa") {
          cost = 0.6;
          countryCode = "SA";
        }

        let val = this.totalBudget / cost;
        this.adLoop = val
        console.log(this.adLoop,"loop");
        let min = Math.round((val * 0.80) / 1e3);
        let max = Math.round((val * 1.20) / 1e3);

        if (min >= 999) {
          min = (min / 1000).toFixed(1) + " million";
        }else{
          min = min.toFixed(0) + "K";
        }

        if (max >= 999) {
          max = (max / 1000).toFixed(1) + " million";
        }else{
          max = max.toFixed(0) + "K";
        }

        return `${min} ~ ${max}`;
      },

      minutes() {
        if (!this.totalBudget) {
          return "-";
        }

        let cost, countryCode;

        if (localStorage.getItem("country_code") === "EG") {
          cost = 6;
          countryCode = "EG";
          var val = this.totalBudget / cost;
        } else if (localStorage.getItem("country_code") === "sa") {
          console.log(this.adLoop*.5);
         var val = this.adLoop * 0.5
          countryCode = "SA";
        }
        var min = Math.round(val * 0.80);
        var max = Math.round(val * 1.20);
        console.log(min+"-"+max);
        if (min >= 1000000) {
          min = (min / 1000000).toFixed(1) + " million";
        } else if (min >= 1000) {
          min = (min / 1000).toFixed(1) + "K";
        } else {
          min = min.toFixed(0);
        }

        if (max >= 1000000) {
          max = (max / 1000000).toFixed(1) + " million";
        } else if (max >= 1000) {
          max = (max / 1000).toFixed(1) + "K";
        } else {
          max = max.toFixed(0);
        }

        return `${min} ~ ${max}`;
      },
 // impressions() {
    //   if (!this.totalBudget) {
    //     return "-";
    //   }
    //   if (this.$store.state.auth.country_code === "EG") {
    //     let cost = 0.09;
    //     let val = this.totalBudget / cost;
    //     let min = Math.round((val * 0.75) / 1e3);
    //     let max = Math.round((val * 1.25) / 1e3);
    //     return `${min}k ~ ${max}k`;
    //   } else if (this.$store.state.auth.country_code === "SA") {
    //     let cost = 0.01125;
    //     let val = this.totalBudget / cost;
    //     let min = Math.round((val * 0.75) / 1e3);
    //     let max = Math.round((val * 1.25) / 1e3);
    //     return `${min}k ~ ${max}k`;
    //   }
    // },
    // distance() {
    //     if (!this.totalBudget) {
    //         return "-";
    //     }
    //     let cost = 0.63;
    //     let val = this.totalBudget / cost;
    //     let min = Math.round((val * 0.75) / 1e3);
    //     let max = Math.round((val * 1.25) / 1e3);

    //     return `${min}k ~ ${max}k`;
    // },
    // ad_loops() {
    //   if (!this.totalBudget) {
    //     return "-";
    //   }

    //   if (this.$store.state.auth.country_code === "EG") {
    //     let cost = 0.65;
    //     let val = this.totalBudget / cost;
    //     let min = Math.round((val * 0.75) / 1e3);
    //     let max = Math.round((val * 1.25) / 1e3);
    //     return `${min}k ~ ${max}k`;
    //   } else if (this.$store.state.auth.country_code === "SA") {
    //     let cost = 0.08125;
    //     let val = this.totalBudget / cost;
    //     let min = Math.round((val * 0.75) / 1e3);
    //     let max = Math.round((val * 1.25) / 1e3);
    //     return `${min}k ~ ${max}k`;
    //   }
    // },

    // minutes() {
    //   if (!this.totalBudget) {
    //     return "-";
    //   }

    //   if (this.$store.state.auth.country_code === "EG") {
    //     let cost = 6;
    //     let val = this.totalBudget / cost;
    //     let min = Math.round(val * 0.75);
    //     let max = Math.round(val * 1.25);
    //     return `${min} ~ ${max}`;
    //   } else if (this.$store.state.auth.country_code === "SA") {
    //     let cost = 0.75;
    //     let val = this.totalBudget / cost;
    //     let min = Math.round(val * 0.75);
    //     let max = Math.round(val * 1.25);
    //     return `${min} ~ ${max}`;
    //   }
    // },
  },
};
</script>

<style></style>
